import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Globe, Plus } from 'lucide-react';

import './Banktype.css';
const url = process.env.REACT_APP_BACKEND_URL;

const AddBanktype = () => {
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({ name: "", number: "" });
  const [focusedFields, setFocusedFields] = useState({ name: false, number: false });
  const navigate = useNavigate();

  const handleFocus = (field) => setFocusedFields(prev => ({ ...prev, [field]: true }));
  const handleBlur = (field) => setFocusedFields(prev => ({ ...prev, [field]: data[field].length > 0 }));
  const onChangeHandler = (e) => setData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    if (!data.name || !data.number) {
      toast.error("Both Bank Type name and number are required");
      return;
    }

    try {
      setSubmitting(true);
      const response = await axios.post(`${url}/api/bank`, data);
      if (response.data.success) {
        toast.success("Banktype added successfully!");
        setData({ name: "", number: "" });
        navigate('/ViewBanktype');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to add Banktype";
      toast.error(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-wrapper">
      <div className="country-form-container">
        <h2 className="form-title">
          <Globe size={20} className="inline mr-2" /> Add New Bank Type
        </h2>
        <div className="header">
          <button onClick={() => navigate('/ViewBanktype')} className="add-button">
            <Plus size={16} /> View Bank Type
          </button>
        </div>

        <form className="country-form" onSubmit={onSubmitHandler}>
          <div className={`form-field ${focusedFields.name || data.name ? 'filled' : ''}`}>
            <input
              type="text"
              name="name"
              value={data.name}
              onChange={onChangeHandler}
              onFocus={() => handleFocus('name')}
              onBlur={() => handleBlur('name')}
              required
            />
            <label>Bank Type (e.g. EVC, Zaad, Bank)</label>
          </div>

          <div className={`form-field ${focusedFields.number || data.number ? 'filled' : ''}`}>
            <input
              type="text"
              name="number"
              value={data.number}
              onChange={onChangeHandler}
              onFocus={() => handleFocus('number')}
              onBlur={() => handleBlur('number')}
              required
            />
            <label>Bank/Wallet Number</label>
          </div>

          <button type="submit" className="submit-btn" disabled={submitting}>
            {submitting ? "Processing..." : "Add Banktype"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddBanktype;
